const PARAGRAPH_SHARE_THIS = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    type
    uuid
    id
    ... on ShareThis {
      id
      shareTitle
      iconShare
      type
      uuid
    }
  }
`;

export default PARAGRAPH_SHARE_THIS;
